import { useRoute, useRouter } from 'vue-router'

type QueryStrings = Record<
  string,
  string | number | string[] | number[] | null | undefined
>

export default function useUpdateRouter() {
  const router = useRouter()
  const route = useRoute()
  const updateQueryString = (payload: QueryStrings) => {
    router.push({
      query: {
        ...route.query,
        ...payload,
      },
    })
  }
  const resetQueryString = (payload?: QueryStrings) => {
    router.push({
      query: payload ? { ...payload } : {},
    })
  }
  return {
    updateQueryString,
    resetQueryString,
  }
}
